export default __webpack_public_path__ + "static/media/v4.c2162d7f.png";